import { createSelector } from '@reduxjs/toolkit';
import { selectParkingTypes } from 'shared/selectors/jsonQuery';

export const selectParkingCheckboxFilter = createSelector(selectParkingTypes, value => ({
  label: 'Парковка',
  checked: !!value && value.length > 0,
}));
